import { FC, useContext } from 'react';
import { Skeleton, Stack, Typography } from '@mui/material';
import { IntroModulesContext } from './IntroModulesContext';

const IntroModuleText: FC = () => {
  const { currentIntroModule, isLoading } = useContext(IntroModulesContext);

  return (
    <Stack gap={1}>
      {isLoading ? (
        <Skeleton height={50} />
      ) : (
        <Typography variant="h5">{currentIntroModule?.title}</Typography>
      )}
      {isLoading ? (
        <Skeleton height={40} />
      ) : (
        <Typography>{currentIntroModule?.body}</Typography>
      )}
    </Stack>
  );
};

export default IntroModuleText;
